import { Modal } from "antd";
import "./androidredirectmodal.scss";
import Appstore from "../../assets/icons/appstore.webp";
import Google from "../../assets/icons/googleplay.webp";
import SvgCloseRound from "../../icons/SvgCloseRound";
import { useMediaQuery } from "react-responsive";

const AndroidRedirectModal = ({ open, close }) => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1019px)" });
  return isTabletOrMobile ? (
    <Modal
      centered
      open={open}
      title=""
      onCancel={close}
      footer={null}
      closeIcon={null}
    >
      <div className={"conatiner"}>
        <div className={"overAll"}>
          <div onClick={close} foote className="close">
            <SvgCloseRound opacity={1} />
          </div>
          <img
            className={"wheel"}
            src={require("../../assets/images/ac_wheel.webp")}
            alt="ac_wheel"
          />
          <span className="title">
            Get expert astrological guidance and insights
          </span>
          <span className="download">Download AstroCure App</span>
          <img
            className={"iphone"}
            alt="iphone"
            src={require("../../assets/images/iphone_14_1.webp")}
          />
          <span className={"now"}>Download Now</span>
          <div className="modal-img-container">
            <img
              onClick={() =>
                (window.location.href = "https://astrocure.co.in/coming-soon/")
              }
              src={Appstore}
              alt="Appstore"
            />
            <img
              src={Google}
              alt="Google"
              onClick={() =>
                (window.location.href =
                  "https://play.google.com/store/apps/details?id=com.astrocure")
              }
            />
          </div>
        </div>
      </div>
    </Modal>
  ) : (
    open && (
      <div className={"conatiner-desktop"}>
        <div className={"overAll"}>
          <div onClick={close} foote className="close">
            <SvgCloseRound opacity={1} />
          </div>
          <div className="wheel-div">
            <img
              className={"wheel"}
              src={require("../../assets/images/ac_wheel.webp")}
              alt="ac_wheel"
            />
            <span className="title">
              Get expert astrological guidance and insights
            </span>
            <span className="download">Download AstroCure App</span>
            <span className={"now"}>Download Now</span>
            <div className="modal-img-container">
              <img
                onClick={() =>
                  (window.location.href =
                    "https://astrocure.co.in/coming-soon/")
                }
                src={Appstore}
                alt="Appstore"
              />
              <img
                src={Google}
                alt="Google"
                onClick={() =>
                  (window.location.href =
                    "https://play.google.com/store/apps/details?id=com.astrocure")
                }
              />
            </div>
          </div>
          <div className={"phone-div"}>
            <img
              className={"iphone"}
              src={require("../../assets/images/iphone_14_1.webp")}
              alt="iphone"
            />
          </div>
        </div>
      </div>
    )
  );
};

export default AndroidRedirectModal;
